import React from "react"
import { Button, File } from "@bw/bits"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"
import { useTranslation } from "react-i18next"

const Wrapper = styled.div`
  flex-direction: column;
  display: flex;
  @media (min-width: ${breakpoints.small}px) {
    grid-template-columns: 5fr 7fr;
  }
  @media (min-width: ${breakpoints.medium}px) {
    display: grid;
    grid-template-columns: 329px 1fr;
  }
`

const Links = styled.div`
  margin-top: 44px;
  max-width: 100%;
  padding-left: 27px;

  @media (min-width: ${breakpoints.small}px) {
    margin-top: 60px;
  }

  > * {
    margin-top: 15px;
  }
`

const Shadow = styled.div`
  > * {
    max-width: 70%;
    height: auto;
    width: 100%;
    display: block;
    box-shadow: 10px 10px 25px rgba(0, 0, 0, 0.1);
    @media (min-width: ${breakpoints.small}px) {
      max-width: 50%;
    }
    @media (min-width: ${breakpoints.medium}px) {
      max-width: 100%;
    }
  }
`

const RightCol = styled.div`
  margin-top: 40px;
`

const Background = styled.div`
  position: relative;
  background-color: var(--brand-${props => props.color});
  min-height: 262px;
  width: 100%;
  padding: 20px;
  @media (min-width: ${breakpoints.small}px) {
    padding-left: 37px;
  }
`
const TranslateText = styled.div`
  transform: translateY(-57px);

  > :last-child {
    margin: 0;
  }

  @media (min-width: ${breakpoints.small}px) {
    transform: translateY(-65px);
  }
  @media (min-width: ${breakpoints.medium}px) {
    transform: translateY(-75px);
  }
`

const TranslateButton = styled.div`
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
`

const TitleSize = styled.div`
  > h2 {
    font-size: 20px;
    line-height: 32px;
    @media (min-width: ${breakpoints.small}px) {
      font-size: 24px;
      line-height: 36px;
    }
    @media (min-width: ${breakpoints.medium}px) {
      font-size: 32px;
      line-height: 42px;
    }
  }
`

const Magazine = ({
  image,
  title,
  excerpt,
  subscribeUrl,
  pdfUrl,
  paroleUrl,
  color,
}) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Shadow>{image}</Shadow>
      <RightCol>
        <Background color={color}>
          <TranslateText>
            <TitleSize>
              <h2>{title}</h2>
            </TitleSize>
            <p>{excerpt}</p>
          </TranslateText>
          {subscribeUrl && (
            <TranslateButton>
              <Button label={t("magazine.button")} to={subscribeUrl} />
            </TranslateButton>
          )}
        </Background>
        <Links>
          {pdfUrl && <File label={t("magazine.pdf")} to={pdfUrl} />}
          {paroleUrl && <File label={t("magazine.parole")} to={paroleUrl} />}
        </Links>
      </RightCol>
    </Wrapper>
  )
}

Magazine.propTypes = {
  image: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  subscribeUrl: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  paroleUrl: PropTypes.string,
  color: PropTypes.oneOf([
    "art-de-vie",
    "love",
    "bebe",
    "urgence",
    "peau",
    "peach",
    "p-plus",
    "soleil-d-hiver",
    "mentalo",
    "nausee",
    "eau-douce",
    "zen",
  ]).isRequired,
}

export { Magazine }
